import {Button, Popover} from "../../__snowpack__/pkg/antd.js";
import React, {useMemo} from "../../__snowpack__/pkg/react.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
export const HelpCenterButton = (props) => {
  const popoverProps = useMemo(() => {
    if (props.popoverList && props.popoverList.length) {
      return {};
    }
    return {visible: false};
  }, [props.popoverList]);
  return /* @__PURE__ */ React.createElement(Wrapper, {
    ...props
  }, /* @__PURE__ */ React.createElement(Popover, {
    placement: "left",
    getPopupContainer: (triggerNode) => triggerNode,
    content: /* @__PURE__ */ React.createElement("div", {
      className: "popover-content"
    }, (props.popoverList || []).map((_, idx) => {
      return /* @__PURE__ */ React.createElement("div", {
        key: idx
      }, idx !== 0 && /* @__PURE__ */ React.createElement("div", {
        className: "popover-content-item-line"
      }), /* @__PURE__ */ React.createElement("a", {
        href: _.href,
        target: "_blank"
      }, /* @__PURE__ */ React.createElement("div", {
        className: "popover-content-item"
      }, /* @__PURE__ */ React.createElement("div", {
        className: "popover-content-icon"
      }, _.icon), /* @__PURE__ */ React.createElement("div", {
        className: "popover-content-text"
      }, _.title))));
    })),
    ...popoverProps
  }, /* @__PURE__ */ React.createElement(Button, {
    target: "_blank",
    className: "help-center-button",
    type: "primary",
    href: props.href,
    icon: /* @__PURE__ */ React.createElement("svg", {
      className: "icon-help",
      width: "22",
      height: "22",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ React.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M0 0h22v22H0z"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M14.292 16.408c.262 0 .48-.084.654-.253a.846.846 0 0 0 .262-.634v-2.07A6.05 6.05 0 0 0 18 8.296c-.03-1.803-.654-3.296-1.876-4.48C14.903 2.635 13.361 2.029 11.5 2c-1.861.028-3.403.634-4.624 1.817C5.654 5 5.029 6.493 5 8.296a6.05 6.05 0 0 0 2.792 5.155v2.07c0 .254.087.465.262.634a.903.903 0 0 0 .654.253h5.584zm-.916-1.816H9.624v-2.155a4.742 4.742 0 0 1-1.985-1.648 4.521 4.521 0 0 1-.807-2.493c.03-1.268.487-2.331 1.374-3.19.887-.86 1.985-1.303 3.294-1.331 1.309.028 2.407.471 3.294 1.33.887.86 1.345 1.923 1.374 3.19-.03.93-.298 1.761-.807 2.494a4.742 4.742 0 0 1-1.985 1.648v2.155zm0 5.408c.262 0 .48-.085.654-.254a.846.846 0 0 0 .262-.633v-.888H8.708v.888c0 .253.087.464.262.633a.903.903 0 0 0 .654.254h3.752z",
      fill: "#FFF",
      fillRule: "nonzero"
    })))
  })));
};
const Wrapper = styled.div`
  position: fixed;
  z-index: 100;
  right: 0px;
  top: 193px;
  .help-center-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 40px;
    background: #6020ff;
    border-radius: 6px 0px 0px 6px;
  }
  .icon-help {
    width: 20px;
    height: 20px;
  }
  .ant-popover-inner-content {
    padding: 4px 12px;
    width: 206px;
    background: #ffffff;
    border-radius: 4px;
  }
  .popover-content-item {
    position: relative;
    cursor: pointer;
    padding-top: 6px;
    padding-bottom: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
      z-index: 1;
      content: '';
      position: absolute;
      width: calc(100% + 24px);
      height: 100%;
      background: #f2f4f6;
      left: -12px;
      opacity: 0;
      transition: opacity, 0.3s;
    }
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
  .popover-content-item-line {
    margin-top: 4px;
    margin-bottom: 4px;
    width: 175px;
    height: 1px;
    background: #dfe3e8;
  }
  .popover-content-icon {
    position: relative;
    z-index: 2;
    margin-right: 18px;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popover-content-text {
    position: relative;
    z-index: 2;
    flex: 1;
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #202d40;
    line-height: 18px;
  }
`;
